import { formatData, sortByDate, sortByDateReverse } from "./utils";

export function getPayments(){
    console.log("getPayments : Start")
    return async function (dispatch){
        dispatch({ type: "FETCH_PAYMENTS_START", payload: "" })
        try {

            const req = await fetch('/money/ca/global/info', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ////'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getPayments res : ', res);
            // check err !
            let payments_list = res.resp ? sortByDate(res.resp, "timePayment") : {}
            
            const formated_payments_list = formatData(payments_list, "paymentID")
            console.log('getPayments res :  formated_payments_list ', formated_payments_list);

            // const formated_payments_list = formatData(payments_list, "timePayment")
            dispatch({
                type: "GET_PAYMENTS",
                payload: formated_payments_list
            })

            dispatch({
                type: "GET_ALL_CLIENTS_PAYMENTS",
                payload: payments_list
            })
            dispatch({ type: "FETCH_PAYMENTS_FULFILLED", payload: "" }) 

        } catch (error) {
            console.log("[ERROR] get payments list : ", error);
            dispatch({ type: "FETCH_PAYMENTS_ERROR", payload: error })
        }
         
    }
}
export function getPaymentsNEW(timeFrom,timeTo,boxAssoId){
    console.log("getPaymentsNEW : Start")
    return async function (dispatch){
        dispatch({ type: "FETCH_PAYMENTS_START", payload: "" })
        try {

            const req = await fetch('/money/payment/list', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    boxAssoID:boxAssoId,
                    from:timeFrom.toISOString(),
                    to:timeTo.toISOString(),
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getPaymentsNEW res : ', res);
            // check err !
            let payments_list = res.resp ? sortByDate(res.resp, "timePayment") : {}
            
            const formated_payments_list = formatData(payments_list, "paymentID")
            console.log('getPaymentsNEW res :  formated_payments_list ', formated_payments_list);

            // const formated_payments_list = formatData(payments_list, "timePayment")
            dispatch({
                type: "GET_PAYMENTS",
                payload: formated_payments_list
            })

            dispatch({
                type: "GET_ALL_CLIENTS_PAYMENTS",
                payload: payments_list
            })
            dispatch({ type: "FETCH_PAYMENTS_FULFILLED", payload: "" }) 

        } catch (error) {
            console.log("[ERROR] getPaymentsNEW list : ", error);
            dispatch({ type: "FETCH_PAYMENTS_ERROR", payload: error })
        }
         
    }
}
export function getIncomeInfo(incomeID){
    return async function (dispatch){
        dispatch({ type: "GET_INCOME_START", payload: "" })
        try {
            const req = await fetch('/money/get/income/info', {
                method: 'POST',
                body: JSON.stringify({incomeID}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getIncomeInfo res : ', res);
            dispatch({ type: "GET_INCOME_FULFILLED", payload: "" }) 
            return res
            
        } catch (error) {
            console.log("[ERROR] get income info compta : ", error);
            dispatch({ type: "GET_INCOME_ERROR", payload: error.message })
            return {error: error.message}
        }
    }
}
export function getSpendingInfo(spendingID){
    return async function (dispatch){
        dispatch({ type: "GET_INCOME_START", payload: "" })
        try {
            const req = await fetch('/money/get/spending/info', {
                method: 'POST',
                body: JSON.stringify({spendingID}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getSpendingInfo res : ', res);
            dispatch({ type: "GET_INCOME_FULFILLED", payload: "" }) 
            return res
            
        } catch (error) {
            console.log("[ERROR] get spending info compta : ", error);
            dispatch({ type: "GET_INCOME_ERROR", payload: error.message })
            return {error: error.message}
        }
    }
}
export function linkPaymentsTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            const req = await fetch('/money/link/to/compta', {
                method: 'POST',
                body: JSON.stringify({payments: data.paymentsID, income_id: data.income_id}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('linkPaymentsTo5000 res : ', res);
            if(!res.error){ // no errors, return new Object 
                try {
                    const req2 = await fetch('/money/link/update/income', {
                        method: 'POST',
                        body: JSON.stringify({income_id: data.income_id, income_total_available: data.total }),
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        credentials: 'same-origin',
                    });
                    let res2 = await req2.json();
                    console.log('linkPaymentsTo5000 res2 update income : ', res2);

                    if(!res2.error){ // no errors, return new Object 
                        dispatch({
                            type: "UPDATE_PAYMENTS_LINK",
                            payload: {list: data.payments, income_id: data.income_id} 
                        })
        
                        dispatch({ type: "LINK_PAYMENTS_FULFILLED", payload: "" }) 
                    
                    } else {
                        dispatch({
                            type: "LINK_PAYMENTS_ERROR",
                            payload: res2.error
                        })
                    }
                } catch (error) {
                    console.log("[ERROR] link payments to compta : ", error);
                    dispatch({
                        type: "LINK_PAYMENTS_ERROR",
                        payload: error.message
                    })
                } 
            
            } else {
                dispatch({
                    type: "LINK_PAYMENTS_ERROR",
                    payload: res.error
                })
            }
        } catch (error) {
            console.log("[ERROR] link payments to compta : ", error);
            dispatch({ type: "LINK_PAYMENTS_ERROR", payload: error.message })
        }     
    }
}
export function unLinkPaymentsTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            const req = await fetch('/money/unlink/to/compta', {
                method: 'POST',
                body: JSON.stringify({income_id: data.income_id , payments: data.paymentsID}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('unLinkPaymentsTo5000 res : ', res);
            if(!res.error){ // no errors, return new Object
                try {
                    const req2 = await fetch('/money/link/update/income', {
                        method: 'POST',
                        body: JSON.stringify({income_id: data.income_id, income_total_available: data.total * -1 }),
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        credentials: 'same-origin',
                    });
                    let res2 = await req2.json();
                    console.log('unLinkPaymentsTo5000 res2 update income : ', res2);

                    if(!res2.error){ // no errors, return new Object 
                        dispatch({
                            type: "UPDATE_PAYMENTS_UNLINK",
                            payload: {list: data.payments} 
                        })
                        dispatch({ type: "LINK_PAYMENTS_FULFILLED", payload: "" }) 
                    
                    } else {
                        dispatch({
                            type: "LINK_PAYMENTS_ERROR",
                            payload: res2.error
                        })
                    }
                } catch (error) {
                    console.log("[ERROR] link payments to compta : ", error);
                    dispatch({
                        type: "LINK_PAYMENTS_ERROR",
                        payload: error.message
                    })
                }             
            } else {
                dispatch({
                    type: "LINK_PAYMENTS_ERROR",
                    payload: res.error
                })
            }
        } catch (error) {
            console.log("[ERROR] link payments to compta : ", error);
            dispatch({ type: "LINK_PAYMENTS_ERROR", payload: error.message })
        }
         
    }
}
